import { render, staticRenderFns } from "./BlockAntrfileEl.vue?vue&type=template&id=58bb37af&scoped=true&"
import script from "./BlockAntrfileEl.vue?vue&type=script&lang=ts&"
export * from "./BlockAntrfileEl.vue?vue&type=script&lang=ts&"
import style0 from "./BlockAntrfileEl.vue?vue&type=style&index=0&id=58bb37af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb37af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
